var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 48 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(34.008 35.296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-2",
    "data-name": "facebook",
    transform: "translate(-34.361 -35.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-3",
    "data-name": "facebook",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 48,
    height: 50,
    transform: "translate(48.353 50.001) rotate(180)",
    fill: "#f0f0f0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M28.363,4.023a1.016,1.016,0,0,0-1.016-1.016H22.264A9.7,9.7,0,0,0,12.1,12.155v5.489H7.016A1.016,1.016,0,0,0,6,18.66v5.286a1.016,1.016,0,0,0,1.016,1.016H12.1V38.584A1.016,1.016,0,0,0,13.115,39.6h6.1a1.016,1.016,0,0,0,1.016-1.016V24.962h5.326a1.016,1.016,0,0,0,1-.752l1.464-5.286a1.016,1.016,0,0,0-.976-1.281H20.231V12.155a2.033,2.033,0,0,1,2.033-1.83h5.082a1.016,1.016,0,0,0,1.016-1.016Z",
    transform: "translate(6.008 3.73)",
    fill: "#f0f0f0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1f85b48d.svg";
export { ForwardRef as ReactComponent };